<template>
  <b-col >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <br>
    <div style="margin-bottom: 0px;">
      <strong v-if="origen == 1" style="color:#0069aa;font-size: 17px;">
        <strong style="color:rgb(19 71 103);font-size: 17px;margin-left: 10px;" v-if="datosDetalle.citaSobreAsignada"> Paciente sobre agendado </strong>
        <strong style="color:rgb(19 71 103);font-size: 17px;margin-left: 10px;" v-else-if="citaIsOverbooking"> Paciente Original</strong>
        <strong style="color:rgb(19 71 103);font-size: 17px;margin-left: 10px;" v-else> Paciente</strong>
      </strong>
      <strong v-else-if="origen == 2 || origen == 3" style="color:#0069aa;font-size: 17px;"> Datos de la cita </strong>
    </div>
    <b-card class="borde-azul-simple pb-0">

      <div v-if="origen != 4" id="popover-movimientos-cita" class="tresPuntitos" style="width: 30px; height: 30px">
           <img v-if="origen == 1"
           width="6px;" alt="paciente"
           src="../../assets/agenda/ellipsis-vertical-solid.svg"/>
      </div>

<!--      <div v-if="origen==3" style="text-align: right">
        <b-badge v-if="datosDetalle.idSubtipoPaciente === 1" style="border:solid gray 1px; background:white; color:black;">{{datosDetalle.subTipoPaciente}}</b-badge>
        <b-badge v-else style="background:#eefff1; color:#49c37f;">{{datosDetalle.subTipoPaciente}}</b-badge>
      </div>-->

      <div class="d-flex justify-content-center" style="margin-top: -10px;">
        <img alt="agenda" v-if="datosDetalle.sexo === 1" style="margin-left: 2%;"  width="125px" src="../../assets/paciente/paciente.png"
        />
        <img alt="agenda" v-else-if="datosDetalle.sexo === 2" style="margin-left: 2%;"  width="125px" src="../../assets/paciente/paciente2.png"
        />
        <img alt="agenda" v-else style="margin-left: 2%;"  width="125px" src="../../assets/paciente/paciente3.png"
        />
      </div>
      <div class=" d-flex justify-content-center" style="position: relative; text-align: -webkit-center; margin-top: 8px;">
        <em v-if="datosDetalle.esPacienteVIP" class="mr-2"  v-b-tooltip.hover.top.v-light
            title="Este Paciente es MISD"
            aria-label="Paciente MISD">
          <font-awesome-icon :icon="['fas', 'crown']" size="lg" style="color: #FFD43B;" />
        </em>
        <router-link
            :to="{ name: 'paciente', params: { id: datosDetalle.idPaciente } }"
        >
          <strong
              v-b-tooltip.hover.top.v-light
              title="Ver perfil del paciente"
              style="color:#0069aa"> <u>{{ datosDetalle.nombrePaciente }} </u> </strong>
        </router-link>


      </div>
      <div class="mt-2 d-flex justify-content-center" style="position: relative; text-align: -webkit-center; margin-top: 8px;">
        <strong >{{ datosDetalle.fechaNacimientoCompleta  }}</strong>
      </div>
      <div class="mt-2 d-flex justify-content-center">
        <strong>{{ datosDetalle.idPaciente }}</strong>
      </div>
      <div class="mt-2 d-flex justify-content-center">
       <strong v-if="datosDetalle && datosDetalle.celular">
    {{ datosDetalle.celular | VMask("(###) - ### - ####") }}
      </strong>
      <strong v-else-if="datosDetalle && datosDetalle.telefonoPadre !== null && datosDetalle.telefonoPadre !== ''">
          {{ datosDetalle.telefonoPadre | VMask("(###) - ### - ####") }}
      </strong>
      <strong v-else>Sin telefonos</strong>

      </div>

      <div v-if="origen == 1 || origen == 4">
        <br>
        <br>

        <div class="mt-2 d-flex justify-content-center" style="position: relative; text-align: -webkit-center;">
          <strong>Porcentaje de confianza:</strong>
        </div>
        <div class=" d-flex justify-content-center">
          <span>{{ datosDetalle.confianza }}</span>
        </div>

        <div class="mt-2 d-flex justify-content-center">
          <strong>Último tx:</strong>
        </div>
        <div class=" d-flex justify-content-center" style="position: relative; text-align: -webkit-center; margin-top: 8px;">
          <p> <span> {{ datosDetalle.ultimoTratamiento }}  </span></p>
        </div>
        <div class=" d-flex justify-content-center">
          <div class="estatusHc" v-if="datosDetalle.estatusHc === 'Completa'" style="background-color: rgb(20 174 92 / 32%);">
            <strong style="color: #14ae5c;"> Hc {{datosDetalle.estatusHc}} </strong>
          </div>
          <div class="estatusHc" v-else style="background-color:rgb(174 20 20 / 32%);">
            <strong style="color:#cd2525"> Hc {{datosDetalle.estatusHc}} </strong>
          </div>
<!--          <router-link v-if="datosDetalle.citaUrgencia"
                       target="_blank"
              :to="{ name: 'HistoriaEmergenciaLink',
              params: { idPaciente: datosDetalle.idPaciente, idClinica: datosDetalle.idClinica  } }"
          ><div class="estatusHc" style="background-color: rgb(20 174 92 / 32%);">
            <strong style="color: #14ae5c;"> <u>Hc {{datosDetalle.estatusHc}}</u></strong>
          </div>
          </router-link>

          <router-link v-else-if="datosDetalle.pacienteEsNino"
                       target="_blank"
                       :to="{ name: 'HistoriaNinoLink',
              params: { idPaciente: datosDetalle.idPaciente, idClinica: datosDetalle.idClinica  } }"
          ><div class="estatusHc" style="background-color: rgb(20 174 92 / 32%);">
            <strong style="color: #14ae5c;"> <u>Hc {{datosDetalle.estatusHc}}</u></strong>
          </div>
          </router-link>

          <router-link v-else
                       target="_blank"
              :to="{ name: 'HistoriaClinicaEdicionPorIdPacienteClinica',
              params: { idPaciente: datosDetalle.idPaciente, idClinica: datosDetalle.idClinica  } }"
          >
          </router-link>
          -->
        </div>
      </div>



      <div v-if="origen == 2" style="font-size: 11px !important;">
        <div class="mt-2 d-flex justify-content-center" style="position: relative; text-align: -webkit-center; margin-top: 8px;">
          <div
              v-if="
                            datosDetalle.tratamientos !== undefined &&
                            datosDetalle.tratamientos !== null 
                          "
          >
            <strong>Tratamiento:</strong>
                          <span
                              v-for="tratamiento in datosDetalle.tratamientos"
                              v-bind:key="tratamiento.idTratamiento"
                          >
                            {{ tratamiento.nombreTratamiento }}<br/>
                          </span></div>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Doctor:</strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.nombreDoctor }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha alta:</strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.fechaCita | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha inicio solicitada: </strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.fechaCita | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha fin solicitada:</strong>
          <span>{{ datosDetalle.fechaCita | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Horario solicitado</strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>   {{ datosDetalle.horaInicioCasilla | formatoHoraDeHora }}
                    -   {{ datosDetalle.horaFinCasilla | formatoHoraDeHora }}</span>
        </div>

      </div>



      <div v-if="origen == 3" style="font-size: 11px !important;">
        <div class="mt-2 d-flex justify-content-center">
          <strong>Porcentaje de confianza: </strong>
        </div>
        <div class=" d-flex justify-content-center">
          <span>{{ datosDetalle.confianza }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Tratamiento: </strong>
        </div>
        <div class=" d-flex justify-content-center">
          <span>{{ datosDetalle.tratamiento }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Doctor: </strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.nombreDoctor }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha alta: </strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.fechaAltaEnListaEspera | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha inicio solicitada: </strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.fechaInicioCitaSolicitada | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Fecha fin solicitada: </strong>]
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.fechaFinCitaSolicitada | formatoFecha }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center">
          <strong>Horario solicitado: </strong>
        </div>
        <div class="d-flex justify-content-center">
          <span>{{ datosDetalle.horaInicioCasilla | formatoHoraDeEntero }}
                    -   {{ datosDetalle.horaFinCasilla | formatoHoraDeEntero }}</span>
        </div>

      </div>

    </b-card>
  </b-col>
</template>

<script>
export default {
  name: "CardPacienteAgenda",
  props:{
    datosDetalle:Object,
    /* origen
    * 1 - Viene de DetalleDeCita
    * 2 - Viene de EnviarAListaEspera
    * 4 - Viene de Daily planning*/
    origen: Number,
    citaIsOverbooking: Boolean
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
}
</script>

<style scoped>
.tresPuntitos{
  position: absolute;
  margin-left: 84%;
  margin-top: -3%;
  cursor: pointer;
}
.estatusHc {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 200px;
  border-radius: 10px 10px 10px 10px;
  color: #333;
}

</style>
